import { c as _c } from "react/compiler-runtime";
import { Card } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import { CardError, CardGrid, CardSkeleton } from '@/components/entity-onboarding-details';
import useEntityOtherInsights from '@/entity/hooks/use-current-entity-other-insights';
import Item from './components/item';
import List from './components/list';
type OtherInsightsProps = {
  /** Shows the insights computed for this onboarding instead of the consolidated ones. */
  onboardingId?: string;
};
const OtherInsights = t0 => {
  const $ = _c(14);
  const {
    onboardingId
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "otherInsights"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const {
    data,
    error
  } = useEntityOtherInsights();
  let t2;
  let t3;
  if ($[1] !== data || $[2] !== error || $[3] !== onboardingId || $[4] !== t) {
    t3 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const insights = (data ?? []).filter(insight => onboardingId ? insight.onboardingId === onboardingId : !insight.onboardingId);
      const lists = [{
        scope: "workflow",
        title: t(_temp)
      }, {
        scope: "behavior",
        title: t(_temp2)
      }, {
        scope: "device",
        title: t(_temp3)
      }] as const;
      if (!data) {
        let t4;
        if ($[7] !== error) {
          t4 = error ? <CardError error={error} /> : <CardSkeleton cards={2} rows={4} />;
          $[7] = error;
          $[8] = t4;
        } else {
          t4 = $[8];
        }
        t3 = t4;
        break bb0;
      }
      if (!insights.length) {
        let t4;
        if ($[9] !== onboardingId || $[10] !== t) {
          t4 = onboardingId ? t(_temp4) : t(_temp5);
          $[9] = onboardingId;
          $[10] = t;
          $[11] = t4;
        } else {
          t4 = $[11];
        }
        let t5;
        if ($[12] !== t4) {
          t5 = <Card.Root><Card.Empty>{t4}</Card.Empty></Card.Root>;
          $[12] = t4;
          $[13] = t5;
        } else {
          t5 = $[13];
        }
        t3 = t5;
        break bb0;
      }
      t2 = <CardGrid>{lists.map(t4 => {
          const {
            scope,
            title
          } = t4;
          const items = insights.filter(insight_0 => insight_0.scope === scope);
          if (!items.length) {
            return null;
          }
          return <List key={scope} title={title}>{items.map(_temp6)}</List>;
        })}</CardGrid>;
    }
    $[1] = data;
    $[2] = error;
    $[3] = onboardingId;
    $[4] = t;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  if (t3 !== Symbol.for("react.early_return_sentinel")) {
    return t3;
  }
  return t2;
};
export default OtherInsights;
function _temp($) {
  return $.onboarding;
}
function _temp2($_0) {
  return $_0.behavior;
}
function _temp3($_1) {
  return $_1.device;
}
function _temp4($_2) {
  return $_2.emptyForOnboarding;
}
function _temp5($_3) {
  return $_3.empty;
}
function _temp6(item) {
  return <Item key={item.name} name={item.name} value={item.value} description={item.description} insightUnit={item.insightUnit} />;
}